/**
 * @param {OpenGraphTagsProps} props
 * @returns {React.ReactElement} The rendered component
 */
const OpenGraphTags = ({
  siteName,
  title,
  type,
  description,
  image,
  metaTitle,
  metaDescription,
  imgProperties,
  url,
}) => {
  return (
    <>
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title || metaTitle} />
      <meta
        name="twitter:description"
        content={description || metaDescription}
      />
      <meta property="og:title" content={title || metaTitle} />
      <meta property="og:type" content={type || 'website'} />
      <meta property="og:url" content={url} />
      {image && (
        <>
          <meta property="og:image" content={image + imgProperties} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="627" />
        </>
      )}
      <meta
        property="og:description"
        content={description || metaDescription}
      />
      <meta property="og:site_name" content={siteName} />
    </>
  );
};

export default OpenGraphTags;
